import React from "react";
import {
  ContentLayout,
  HeaderBreadcrumbs,
  ServerPaginatedTable,
} from "../../../shared";
import { MorePopOver } from "../../Orders";
import { SendEmailsDialog } from "../../ClientAccountsV2/components";
import { ListItem, Stack, TextField, Typography, Button } from "@mui/material";
import moment from "moment";
import InputControl from "../../../shared/components/InputControl";
import { useAgedDebtorsReport } from "../hooks";

export const AgedDebtorsReport = () => {
  const {
    state,
    storeList,
    breadcrumbs,
    isStoreAdmin,
    handleDownloadEmail,
    toggleSendEmailDialog,
    handleSendEmail,
    handleFilterChange,
    gotoPage,
    setPageSize,
    handleApplyFilter,
  } = useAgedDebtorsReport();

  const columns = React.useMemo(() => [], []);
  const formattedDate = moment().format("DD MMM YYYY");

  const { dataList, isLoading, headers, pagination } = state;

  const getRowStyle = (rowData) => {
    if (rowData.total_name) {
      return {
        backgroundColor: "#1560D414",
        fontWeight: "bold",
      };
    }
    if (rowData.percentage_total_name) {
      return {
        backgroundColor: "#D6E0DA",
        fontWeight: "bold",
      };
    }
    return {};
  };

  const getColumnStyle = (rowData, cell) => {
    // // Style for total row columns
    if (rowData.total_name || rowData.percentage_total_name) {
      return {
        fontWeight: "500",
      };
    }

    if (cell.column.Header === "Total") {
      return {
        backgroundColor: "rgba(0, 0, 0, 0.03)",
      };
    }

    return {};
  };

  return (
    <ContentLayout
      title="Aged Debtors Report"
      breadcrumbs={<HeaderBreadcrumbs links={breadcrumbs} />}
      rightContent={
        <MorePopOver
          sendInvoiceLabel="Send Email"
          SendInvoice={() => toggleSendEmailDialog(true)}
          DownloadInvoice={handleDownloadEmail}
        />
      }
    >
      <ServerPaginatedTable
        columns={headers}
        data={dataList}
        isLoading={isLoading}
        searchBar={false}
        pagination={pagination}
        key={[]}
        defaultSearch={false}
        gotoPage={gotoPage}
        setPageSize={setPageSize}
        handleSort={() => {}}
        sortByGlobal={[]}
        tableTitle={
          <Stack
            sx={{
              flexDirection: "row",
              gap: "10px",
            }}
          >
            <InputControl
              type="datePicker"
              name="settlement_date"
              label="Select Date"
              inputFormat="dd-MM-yyyy"
              disableFuture
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              value={state.filter.date}
              onChange={(e) =>
                handleFilterChange({
                  target: {
                    name: "date",
                    value: e,
                  },
                })
              }
              sx={{
                width: "200px",
              }}
            />
            {!isStoreAdmin ? (
              <InputControl
                type="dropdown"
                name="store"
                label="Store"
                options={storeList}
                value={state.filter.store}
                onChange={(_, value) =>
                  handleFilterChange({ target: { name: "store", value } })
                }
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderTags={() => <></>}
                renderOption={(props, option) => (
                  <ListItem {...props} key={option.id}>
                    {option.name}
                  </ListItem>
                )}
                sx={{ width: 300 }}
                componentsProps={{
                  paper: {
                    sx: {
                      width: "fit-content",
                      minWidth: 300,
                    },
                  },
                }}
                // Add these props to remove the clear indicator
                disableClearable={true}
                components={{
                  ClearIndicator: null,
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Store" placeholder="Store" />
                )}
              />
            ) : (
              ""
            )}
          </Stack>
        }
        headerRightContent={
          <>
            <Button variant="text" color="info" onClick={handleApplyFilter}>
              Generate
            </Button>
          </>
        }
        getRowStyle={getRowStyle}
        getColumnStyle={getColumnStyle}
      />

      <SendEmailsDialog
        open={state.isSendEmailDialogOpen}
        key={state.isSendEmailDialogOpen}
        handleClose={() => toggleSendEmailDialog(false)}
        disableCloseOnBackgroundClick
        helperText="The Aged Debtors Report will be sent to"
        handleFormSubmit={handleSendEmail}
        submitting={false} //send button loading
        defaultEmails={[]} //default emails
      />
    </ContentLayout>
  );
};
